import { motion } from "framer-motion";
import {
  GraduationCap, CreditCard, Receipt, BookOpen, Laptop,
  MessageSquare, UserCheck, ShieldCheck,
} from "lucide-react";
import { MODULES } from "@/data/landingData";

const ICONS = { GraduationCap, CreditCard, Receipt, BookOpen, Laptop, MessageSquare, UserCheck, ShieldCheck };

export const Features = () => {
  return (
    <section id="fitur" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400">Modul Lengkap</span>
          <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Delapan Modul, Satu Sistem Terpadu
          </h2>
          <p className="mt-4 text-base text-slate-300">
            Semua kebutuhan operasional sekolah modern tersedia sejak hari pertama — tanpa perlu berlangganan banyak aplikasi terpisah.
          </p>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {MODULES.map((m, i) => {
            const Icon = ICONS[m.icon];
            return (
              <motion.div
                key={m.id}
                data-testid={`feature-${m.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.08 }}
                className="group rounded-2xl border border-cyan-500/15 bg-[#0D1424] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/50 hover:shadow-[0_0_25px_rgba(0,240,255,0.15)]"
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400/15 to-violet-600/15 text-cyan-400 transition-colors group-hover:from-cyan-400/30 group-hover:to-violet-600/30">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-heading text-base font-semibold text-white">{m.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{m.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
